var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavorite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.565 2c1.637 0 3.179.693 4.335 1.881 1.253 1.188 1.927 2.871 1.735 4.555 0 1.683-.675 3.366-1.831 4.554l-8.479 8.713c-.192.198-.385.297-.674.297s-.482-.099-.675-.297L3.498 12.99C2.34 11.802 1.667 10.12 1.667 8.436s.674-3.367 1.927-4.555a6.104 6.104 0 0 1 8.768 0l.385.396.386-.396A6.27 6.27 0 0 1 17.565 2m-4.818 17.624 7.804-8.02c.868-.891 1.35-1.98 1.35-3.168s-.482-2.278-1.253-3.169c-.867-.792-1.927-1.287-3.084-1.287-1.252 0-2.312.495-3.179 1.287l-.963 1.09a.914.914 0 0 1-1.35 0l-1.06-1.09c-.866-.89-1.926-1.287-3.082-1.287-1.06 0-2.216.396-2.987 1.287S3.69 7.247 3.69 8.436c0 1.188.386 2.277 1.253 3.168z",
  clipRule: "evenodd"
})));
export default SvgFavorite;